module.exports = __webpack_public_path__ + "img/theme6.b7fd3817.png";